export type PromiseTransfer<T> = [(p: Promise<T> | T) => void, Promise<T>];
export function promiseTransfer<T>(): PromiseTransfer<T> {
  let _resolve: (v: T) => void;
  let _reject: (e: any) => void;

  const promise = new Promise<T>((resolve, reject) => {
    _resolve = resolve;
    _reject = reject;
  });

  const transfer = (p: Promise<T> | T) => {
    if (isThenable(p)) {
      p.then(_resolve).catch(_reject);
    } else {
      _resolve(p);
    }
  };

  return [transfer, promise];
}

function isThenable(t: any): t is Promise<any> {
  return "then" in t && typeof t.then === "function";
}
